export default __webpack_public_path__ + "img/neraca-icon.cd69b84d.svg";